// @ts-check
import styled from 'styled-components';
import Text from 'components/base/Text';
import { Flex, Padding } from 'components/base/layout-components';
import { SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import * as LighthouseService from 'common/services/lighthouse.service';
import Link from '@material-ui/core/Link';
import { ARTICLE_IDS } from 'common/constants/constants';
import { LBButton } from '@linearb/buzz';

const TeamMembersBox = styled.div`
  border-top-left-radius: 0.45rem;
  border-top-right-radius: 0.45rem;
  background-color: ${getColor('zircon')};
  width: 100%;
`;

const TeamMembersFlexBox = styled(Flex)`
  overflow: hidden;
  min-height: 5rem;
`;

export const TeamMembersBar = ({ onEditTeamClick, onThisIsMyTeamClick }) => {
  return (
    <TeamMembersBox>
      <TeamMembersFlexBox direction='row' items='center'>
        <Flex grow='1' pl='medium' items='baseline'>
          <Text ellipsisAfter size='large' pr={SIZES.tiny}>
            Are these your people?
          </Text>
          <Text ellipsisAfter pr={SIZES.tiny}>
            it can be your immediate team and others with work you care about
          </Text>
          <Link
            onClick={() =>
              LighthouseService.navigateArticle(ARTICLE_IDS.INITIAL_TEAM)
            }
          >
            learn more
          </Link>
        </Flex>
        <Flex pr='small'>
          <Padding r='small'>
            <LBButton onClick={onThisIsMyTeamClick}>This is my team</LBButton>
          </Padding>
          <LBButton variant='outline' onClick={onEditTeamClick}>
            Edit Team
          </LBButton>
        </Flex>
      </TeamMembersFlexBox>
    </TeamMembersBox>
  );
};
